// API quiet is a bounded loading heuristic, never proof that all pixels are ready.
export function createDiagnosticsNavigation({ clock, now, uuid, emit, revise, tabId, schedule = setTimeout, cancel = clearTimeout, frame = callback => requestAnimationFrame(callback), hidden = () => document.hidden }) {
    let current = null, timer = null;
    const contexts = new Map();
    const iso = () => new Date(now()).toISOString();
    function quiet(context) {
        if (timer) cancel(timer);
        if (!context || context.pending.size || context.quiet || context.closed) return;
        timer = schedule(() => {
            frame(() => frame(() => {
                if (context.pending.size || context.closed || context.quiet) return;
                context.quiet = true;
                revise(context.event, { api_quiet_ms: Math.max(0, clock() - context.started), pending_requests: 0, visibility_hidden: context.event.visibility_hidden || hidden() });
            }));
        }, 500);
    }
    function enter(page, label = "route_enter") {
        leave("interrupted");
        const id = uuid();
        const event = emit({ id, tab_id: tabId, navigation_id: id, revision: 1, kind: "navigation", page, label, started_at: iso(), outcome: "in_progress", pending_requests: 0, visibility_hidden: hidden() });
        if (!event) return null;
        current = { id, event, started: clock(), pending: new Set(), quiet: false, closed: false };
        contexts.set(id, current);
        quiet(current);
        return current;
    }
    function leave(outcome = "completed") {
        if (!current || current.closed) return;
        current.closed = true;
        revise(current.event, { ended_at: iso(), duration_ms: Math.max(0, clock() - current.started), outcome: outcome === "error" ? "error" : current.quiet && !current.pending.size ? "completed" : "interrupted", pending_requests: current.pending.size });
        current = null;
        if (timer) cancel(timer);
    }
    function begin(id) {
        if (!current) return null;
        current.pending.add(id);
        revise(current.event, { pending_requests: current.pending.size });
        return current.id;
    }
    function finish(navigationId, id) {
        const context = contexts.get(navigationId);
        if (!context) return;
        context.pending.delete(id);
        revise(context.event, { pending_requests: context.pending.size });
        quiet(context);
    }
    function milestone(label) {
        if (!current) return;
        emit({ id: uuid(), tab_id: tabId, navigation_id: current.id, revision: 1, kind: "milestone", page: current.event.page, label, started_at: iso(), outcome: "completed", duration_ms: Math.max(0, clock() - current.started), visibility_hidden: hidden() });
    }
    function visibility() {
        if (current && hidden()) { revise(current.event, { visibility_hidden: true }); milestone("visibility_hidden"); }
    }
    return { enter, leave, begin, finish, milestone, visibility, current: () => current, reset() { leave("interrupted"); contexts.clear(); } };
}
